import React from 'react';
export function Footer() {
  return <footer className="bg-background border-t border-border" data-id="element-18">
      <div className="container py-10 md:py-12" data-id="element-19">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-20">
          <div data-id="element-21">
            <div className="flex items-center gap-1" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/99D4e53cgjQaS46pLTjE3K/image.png" alt="reddog.studio logo" className="h-6 w-6 object-contain shrink-0 -mr-0.5" data-id="element-23" />
              <p className="font-mono text-sm font-medium tracking-tight text-foreground" data-id="element-24">
                reddog<span className="text-muted-foreground" data-id="element-25">.studio</span>
              </p>
            </div>
            <p className="text-sm text-muted-foreground mt-2" data-id="element-26">
              AI systems built on-site, shipped to production.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8" data-id="element-27">
            <a href="mailto:hello@reddog.studio" className="font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors" data-id="element-28">
              hello@reddog.studio
            </a>
            <a href="#start-engagement" onClick={e => {
            e.preventDefault();
            document.getElementById('start-engagement')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="font-mono text-xs uppercase tracking-widest text-signal hover:text-signal/80 transition-colors underline underline-offset-4" data-id="element-29">
              Book a call
            </a>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2" data-id="element-30">
          <p className="font-mono text-xs text-muted-foreground/70" data-id="element-31">
            © 2026 reddog.studio
          </p>
          <p className="font-mono text-xs text-muted-foreground/70" data-id="element-32">
            Saigon — Worldwide
          </p>
        </div>
      </div>
    </footer>;
}